import React, { useEffect } from 'react';
import BottomSlide from './subComponents/BottomSlide';
import ContentBlock from './subComponents/ContentBlock';

interface I_SlidePage {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
    title: string;
    children: JSX.Element;
    isHeaderShow?: boolean;
    side?: string;
}

const SlidePage: React.FC<I_SlidePage> = ({
    visible,
    children,
    title,
    setIsVisible,
    isHeaderShow = true,
    side,
}) => {
    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        const reset = () => {
            html.style.overflow = '';
            body.style.overflow = '';
        };
        if (visible) {
            html.style.overflow = 'hidden';
            body.style.overflow = 'hidden';
        } else {
            reset();
        }
        return () => {
            reset();
        };
    }, [visible]);

    return (
        <BottomSlide side={side}>
            <ContentBlock
                visible={visible}
                setIsVisible={setIsVisible}
                title={title}
                isHeaderShow={isHeaderShow}
                side={side}
            >
                {children}
            </ContentBlock>
        </BottomSlide>
    );
};

export default SlidePage;
